import React, { useEffect, useState } from 'react';
import Menu from '../../components/Menu';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Swal from 'sweetalert2'
import useOrdenacao from '../../services/ordenacao';
import { listaTransmissoes, deletaTransmissao, atualizaOrdemTransmissoes } from '../../services/mysql'

export default function Produtos() {
    const [academias, setAcademias] = useState([])
    const ordem = useOrdenacao(academias, setAcademias, atualizaOrdemTransmissoes);

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('userd7'))
        mensagemLoading('Buscando Transmissões...')
        const data = {
            id: user.id,
            perfil: user.perfil
        }
        listaTransmissoes(data).then((res) => {
            Swal.close()
            if (!Array.isArray(res)) throw new Error('Não foi possível carregar a lista.');
            setAcademias(res)
        }).catch(() => mensagemErro('Não foi possível carregar a lista. Tente novamente.'))
    }, [])

    function removeTransmissao(item) {
        Swal.fire({
            title: 'Aviso',
            text: 'Deseja remover a transmissão ' + item.nome + ' ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                mensagemLoading('Deletando Transmissão..')
                deletaTransmissao(item.id).then((res) => {
                    if (res.erro) {
                        console.log(res)
                        mensagemErro(res.message)
                    } else {
                        mensagemSucesso('Transmissão removido com sucesso')
                    }
                })

            }
        });
    }

    // Mensagens
    function mensagemAlerta(msg) {
        Swal.fire('Alerta', msg, 'warning')
    }

    function mensagemErro(msg) {
        Swal.fire('Erro', msg, 'error')
    }
    function mensagemSucesso(msg) {
        Swal.fire('Sucesso', msg, 'success').then(() => {
            mensagemLoading('Atualizando Eventos...')
            const user = JSON.parse(localStorage.getItem('userd7'))
            const data = {
                id: user.id,
                perfil: user.perfil
            }
            listaTransmissoes(data).then((res) => {
                Swal.close()
                setAcademias(res)
                ordem.redefinir()
            })
        })
    }

    function mensagemLoading(msg) {
        Swal.fire({
            title: 'Aguarde',
            html: msg,
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading()
            },
        })
    }
    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <Menu />
                <div class="layout-page">
                    <div>
                        <Header />
                        <div className="content-wrapper">
                            <div className="container-xxl flex-grow-1 " style={{marginTop:20}}>
                                <div className="card">
                                    <div className='row'>
                                        <div className='col-md-10'>
                                            <h5 className="card-header">Transmissões</h5>
                                        </div>
                                        <div className='col-md-2' style={{ padding: 10 }}>
                                            <a href='/cadastroTransmissao' className="btn btn-primary me-2" >
                                                Nova
                                            </a>
                                        </div>
                                    </div>
                                    <div className="px-4 pb-3">
                                        <p className="mb-2">Arraste a linha para alterar a ordem ou use as setas do teclado na coluna Ordem. Depois clique em Atualizar ordem.</p>
                                        <button type="button" className="btn btn-primary" disabled={!ordem.alterada || ordem.salvando} onClick={ordem.atualizar}>
                                            {ordem.salvando ? 'Salvando...' : 'Atualizar ordem'}
                                        </button>
                                        {ordem.alterada && <span className="ms-3" role="status">Existem alterações de ordem não salvas.</span>}
                                    </div>
                                    <div className="table-responsive text-nowrap">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Ordem</th>
                                                    <th>Imagem</th>
                                                    <th>Transmissão</th>
                                                    <th>Valor</th>
                                                    <th>Status</th>
                                                    <th>Free</th>
                                                    <th>Ação</th>
                                                    <th>Remover</th>
                                                </tr>
                                            </thead>
                                            <tbody className="table-border-bottom-0">
                                                {academias.map((transmissao, index) =>
                                                    <tr key={transmissao.id} {...ordem.linha(index)}>
                                                        <td tabIndex={ordem.salvando ? -1 : 0} title="Arraste a linha ou use as setas para cima e para baixo" {...ordem.controleOrdem(index)}>{transmissao.ordem ?? '—'}</td>
                                                        <td>{<img draggable={false} src={transmissao.urlImagem} alt="user-avatar" className="d-block rounded" height={50} width={50} id="uploadedAvatar" />}</td>
                                                        <td>{transmissao.nome}</td>
                                                        <td>{transmissao.valor? transmissao.valor.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }):0}</td>
                                                        <td>
                                                            {transmissao.status === 'ATIVO' ?
                                                                <span class="badge bg-label-success me-1">Ativo</span>
                                                                :
                                                                <span class="badge bg-label-danger me-1">Inativo</span>
                                                            }
                                                        </td>
                                                        <td>
                                                            {transmissao.free === 'SIM' ?
                                                                <span class="badge bg-label-success me-1">Sim</span>
                                                                :
                                                                <span class="badge bg-label-danger me-1">Não</span>
                                                            }
                                                        </td>
                                                        <td>
                                                            <button onClick={() => window.location = '/cadastroTransmissao?i=' + transmissao.id} type="button" className="btn rounded-pill btn-icon btn-primary">
                                                                <span className="tf-icons bx bx-search" />
                                                            </button>
                                                        </td>
                                                        <td>
                                                            <button disabled={ordem.salvando} onClick={() => removeTransmissao(transmissao)} type="button" className="btn rounded-pill btn-icon btn-danger">
                                                                <span className="tf-icons bx bx-trash" />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )}
                                                {academias.length === 0 ?
                                                    <p style={{ textAlign: 'center', padding: 10 }} >Sem transmissões cadastradas</p>
                                                    :
                                                    null
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>

                            <Footer />
                            <div className="content-backdrop fade" />
                        </div>
                        {/* Content wrapper */}
                    </div>
                </div>

            </div>
        </div>

    );
}